import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

interface SalaryPermission {
  salary_view: (string | number)[];
  salary_edit: (string | number)[];
  salary_delete: (string | number)[];
}

type GlobalState = {
  salaryPermission: SalaryPermission;
};

const initialState: GlobalState = {
  salaryPermission: {} as SalaryPermission,
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setSalaryPermission(state, action: PayloadAction<any>) {
      state.salaryPermission = action.payload;
    },
  },
});
// Action
export const { setSalaryPermission } = globalSlice.actions;
// Selector global
const globalSelector = (state: RootState) => state.global;
//Selector salaryPermission
export const selectSalaryPermission = createSelector(
  globalSelector,
  (state) => state.salaryPermission,
);
export default globalSlice;
